// @flow
import React from 'react';

import { createEnchereUpdateOeuvre, updateEnchere } from 'Api';
import PrixForm from 'pages/Avila/Prix/Form'

import FormModal from './FormModal'
import { useTranslation } from 'react-i18next'

type Props = {
    oeuvreid: string,
    onClose: any => any,
    actions: Array<any>,
    data: any,
    onSave: any => any,
    isMultiple: boolean
}
export default ({
    onClose,
    actions = [],
    data,
    oeuvre,
    oeuvreid,
    onSave = () => {},
    isMultiple = false
}: Props) => {
    
    const { t } = useTranslation();

    return (

        <FormModal
            title={t("prix")}
            data={data}
            onClose={onClose}
            FormComponent={({ data, onChange }) => (
                <PrixForm
                    isMultiple={isMultiple}
                    data={data}
                    onChange={onChange}
                />
            )}

            onSave={onSave}
            updateMethod={({ data }) => updateEnchere({ oeuvreid, data })}
            createMethod={({ data }) => createEnchereUpdateOeuvre({ oeuvre, data })}
        />
    )
}